import type { Route } from "./+types/$locale.privacy";
import { buildSeoMeta } from "@/components/seo/meta";

export { PrivacyPolicyPage as default } from "@/features/legal/routes/PrivacyPolicyPage";

export function meta({ params }: Route.MetaArgs) {
    const locale = (params.locale as string) ?? "en";
    return buildSeoMeta({
        title: "Privacy Policy",
        description:
            "Privacy Policy for Stork Rentals - How we collect, use, and protect your personal data.",
        path: "/privacy",
        locale,
        availableLocales: [{ code: "en" }],
    });
}
